import { useState } from "react";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import successHeadPopup from "../Asserts/images/success-head-popup.svg";
import successTick from "../Asserts/images/success-tick.svg";

function PaymentSuccPopup({ round, leagueId, oid, mbmeReferenceId }) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
    navigate("/dashboard");
  };

  if (!isOpen) return null;

  return (
    // <div className="fixed inset-0 z-50 bg-black/40 flex justify-center items-center p-2">
    //   <div className="bg-white rounded-lg shadow-lg w-full max-w-sm max-h-[90vh] flex flex-col overflow-hidden relative">
    //     {/* Close Button (X) */}
    //     <button
    //       onClick={handleClose} // Close the popup
    //       className="absolute top-2 right-2 text-gray-600 text-2xl hover:text-black"
    //     >
    //       &times;
    //     </button>

    //     {/* Success Message */}
    //     <div className="flex flex-col justify-center gap-4 p-4 pt-10">
    //       <p className="flex justify-center text-[green]">Payment Successfully Done.</p>
    //       <p className="text-sm">
    //         Order Id: <span className="break-all whitespace-normal">{oid}</span>
    //       </p>
    //     </div>

    //     {/* Footer Buttons */}
    //     <div className="p-4 justify-center flex gap-3">
    //       <button
    //         className="p-4 bg-[#00C05B] text-white font-bold text-base sm:text-lg py-1 sm:py-2 rounded-lg shadow-lg transition"
    //         onClick={handleClose} // Close the popup
    //       >
    //         Ok
    //       </button>
    //     </div>
    //   </div>
    // </div>

    <div
      className="fixed inset-0 z-50 bg-black/90 flex justify-center items-center p-4"
      onClick={handleClose} // Close on overlay click
    >
      {/* Optional Toaster */}
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            fontWeight: "700",
            borderRadius: "0px !important",
            border: "1px solid #1BA56F",
          },
        }}
      />

      <div
        className="bg-white rounded-lg shadow-lg max-w-md w-full max-h-[80vh] flex flex-col overflow-hidden relative"
        onClick={(e) => e.stopPropagation()} // Prevent click inside modal from closing
      >
        {/* Close button */}
        <button
          className="absolute right-2 md:right-6 text-[#787878] text-xl sm:text-2xl w-8 h-8 flex items-center justify-center hover:text-black transition"
          onClick={handleClose}
          aria-label="Close"
        >
          ×
        </button>

        {/* Header Image with overlay text */}
        <div className="relative w-fit mx-auto">
          <img
            src={successHeadPopup}
            alt="Payment Success"
            className="w-[220px] h-auto"
          />
          <p className="absolute inset-0 flex items-center justify-center text-white font-bold text-center px-4">
            Token Added
          </p>
        </div>

        {/* Content: Tick icon + OK button */}
        <div className="p-6 py-2 flex flex-col items-center">
          <img src={successTick} alt="Success Tick" className="w-[50px]" />
          <p>Thank you! Your tokens was successfully added.</p>
          <div className="flex flex-col justify-center gap-4 p-4 pt-10">
            <p className="text-sm">
              Order Id:{" "}
              <span className="break-all whitespace-normal">{oid}</span>
            </p>
          </div>
          <button
            className="w-[50%] sm:w-[40%] px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg font-semibold transition-colors duration-200 text-sm sm:text-base bg-[#00C05B] text-white hover:bg-[#00a24b]"
            onClick={handleClose}
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccPopup;
